import * as angular from "angular";

const events = {
  addressChanged: 'address-changed'
};

angular
  .module('bringoz.admin.accounts')
  .constant('accountConstants', {
    events: events
  });
